<template>

  
  <div class="row">
    <div  class="card-content fond" >
    <h4  id = "welcom">Bienvenue dans votre application</h4>
    </div>
    <div class="card">
      <div class="card-content">
        <!-- <div class="row "> -->
        <div class="input-field col s6">
          <input
            id="login"
            v-model="login"
            type="text"
            class="validate"
            required
          />
          <label for="login">Identifiant ou adresse e-mail</label>
          <span class="helper-text" data-error="Field is required"></span>
        </div>
        <!-- </div>

        <div class="row "> -->
        <div class="input-field col s6">
          <input
            id="pass"
            v-model="pass"
            type="password"
            class="validate"
            required
          />
          <label for="pass">Mot de passe</label>
          <span class="helper-text" data-error="Field is required"></span>
        </div>
        <!-- </div> -->

        <p>
          <label>
            <input
              type="checkbox"
              v-model="isMed"
              class="filled-in"
              checked="checked"
            />
            <span>vous êtes un professionnel de la santé</span>
          </label>
        </p>
        <br />

        <buttom class="btn" @click="checkLogin" type="button"
          >Se connecter</buttom
        >
      </div>
    </div>
    <span id = "marge" v-if="errorLogin" style="color: #ff8a80">
      ERREUR: Identifiant, adresse de messagerie ou mot de passe non valide.
    </span>
    <div v-if="errorAgenda" style="color: #ff8a80">
      <h4>Votre agenda médicale n'a pas été trouvée. </h4>
          <p>Vous devez contacter votre médecin et lui fournir 
            des informations plus précises sur les traitements 
            et les données dans votre agenda medicale.
        </p>
    </div>
  </div>
 
</template>

<script>
export default {
  data: () => ({
    login: "",
    pass: "",
    isMed: false,
    errorLogin: false,
    errorAgenda: false
  }),
  computed: {
    agendaList() {
      return this.$store.getters.agendaList;
    }
  },
  methods: {
    checkLogin() {
      if (this.isMed) {
        if (this.login === "White" && this.pass === "0102") {
          // this for Medcine
          const userSession = {
              userName: this.login , 
              isMed: this.isMed
            }
            console.log('userSession: ',userSession)
          this.$store.dispatch('saveSession', userSession)
          this.$router.push("/list");
        } else {
          this.errorLogin = true;
        }
      } else {
        if (this.login === "Maximus" && this.pass === "mmmm") {

          // !!-INFO-!! start block Hes --\
          let idArray = [];
          for (let i = 0; i < this.agendaList.length; i++) {
            if (this.login === this.agendaList[i].patient) {
              idArray.push(this.agendaList[i].id);
            }
          }
          // console.log('id agendas of user:',idArray)
          if (idArray.length === 0) {
            // console.log('No agendas for user ',this.login)
            this.errorAgenda = true
          }else{
          // this for Patient
            // console.log(idArray[0])
            const userSession = {
              userName: this.login , 
              isMed: this.isMed
            }
            console.log('userSession: ', userSession)
            this.$store.dispatch('saveSession', userSession)

            this.$router.push('/agenda/' + idArray[0])
          }

          // !!-INFO-!! fin block Hes --/

        } else {
          this.errorLogin = true;
        }
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.row .col.s6 {
  width: 100%;
}
.card {
  width: 500px;
  margin-left: 27%;
  margin-top:2%;
  
}



#marge{

  margin-left : 27.5%;
}

#welcom{
    
    margin-left:5%;
    margin-top: 2%;
    color: white ;
    

}
.btn{

  cursor: pointer;
}

.fond{

  width: 45%;
  height: 50%;
  border : solid 1px #26a69a;;
  background-color:  #26a69a;
  box-shadow: 2px 2px 3px rgb(110, 110, 110);
  margin-left: 24%;
  margin-top: 10%;
  
}


</style>